
import React from "react";
import { UseFormReturn } from "react-hook-form";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { WorksheetFormValues } from "./worksheetFormSchema";

interface WorksheetFormFieldsProps {
  form: UseFormReturn<WorksheetFormValues>;
}

export const WorksheetFormFields: React.FC<WorksheetFormFieldsProps> = ({ form }) => {
  return (
    <>
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormItem>
            <FormLabel>ชื่อชีท</FormLabel>
            <FormControl>
              <Input {...field} placeholder="ชื่อชีท" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="subject"
        render={({ field }) => (
          <FormItem>
            <FormLabel>วิชา</FormLabel>
            <FormControl>
              <Input {...field} placeholder="วิชา" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="grade_level"
        render={({ field }) => (
          <FormItem>
            <FormLabel>ระดับชั้น</FormLabel>
            <FormControl>
              <Input {...field} placeholder="เช่น ม.3, Grade 10, ป.6" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="semester"
        render={({ field }) => (
          <FormItem>
            <FormLabel>เทอม</FormLabel>
            <FormControl>
              <Input {...field} placeholder="เช่น 1, 2" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="fs_name"
        render={({ field }) => (
          <FormItem>
            <FormLabel>ชื่อช้อป/สาขา</FormLabel>
            <FormControl>
              <Input {...field} placeholder="ชื่อช้อป/สาขา" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="document_urls"
        render={({ field }) => (
          <FormItem>
            <FormLabel>ลิงค์เอกสาร (แต่ละลิงค์ใส่บรรทัดใหม่)</FormLabel>
            <FormControl>
              <Textarea 
                {...field} 
                placeholder="https://example.com/document1&#10;https://example.com/document2"
                className="h-24"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="status"
        render={({ field }) => (
          <FormItem>
            <FormLabel>สถานะ</FormLabel>
            <FormControl>
              <Input {...field} placeholder="สถานะ" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
